export default "__VITE_ASSET__BezThFm___"